let $favoritesContainer;
let $favoriteButton;
let $favoritesLoaders;
let firstLoadFavorites = true;
const favoritesI18n = (typeof window !== 'undefined' && window.novioI18n && window.novioI18n.favorites)
  ? window.novioI18n.favorites
  : {};

function favoritesT(key) {
  return typeof favoritesI18n[key] === 'string' ? favoritesI18n[key] : key;
}

$(document).ready(($) => {
  $favoritesContainer = $('.js-favorites-container');
  $favoriteButton = $('.js-favorite-button');
  $favoritesLoaders = $('.js-loader');
  if ($favoritesContainer.length !== 0 && firstLoadFavorites) {
    getFavorites();
    firstLoadFavorites = false;
  }
  if ($favoriteButton.length !== 0) {
    getFavoriteState();
  }

  // Use event delegation for dynamically loaded elements
  $(document).on('click', '.js-favorite-button', function () {
    const $button = $(this);
    const postId = $button.data('postid');
    const state = $button.data('state');
    let newState;
    let newText;
    if (state === 'true') {
      newState = 'false';
      newText = favoritesT('removed_from_favorites');
    } else {
      newState = 'true';
      newText = favoritesT('added_to_favorites');
    }

    // In de favorietenlijst zelf halen we het item direct weg uit de UI.
    if (newState === 'false' && $button.closest('.js-favorites-container').length !== 0) {
      removeFavoriteItem($button);
      setFavoriteState(postId, newState)
        .done(() => {
          // Geen extra UI-update nodig bij succes; item is al optimistisch verwijderd.
        })
        .fail(() => {
          getFavorites();
        });
      return;
    }

    setFavoriteState(postId, newState);
    setFavoriteButtonState($button, newState);
    const messageContainer = $button.next('.js-favorite-message');
    messageContainer.html(newText);
    messageContainer.show();
    window.setTimeout(() => {
      messageContainer.hide();
    }, 2000);
  });

  $(document).on('click', '.js-remove-favorite', function (e) {
    e.preventDefault();
    const $button = $(this);
    const postId = $button.data('postid');
    const originalHtml = $button.html();

    $button.html('<i class="fas fa-circle-notch fa-spin"></i>');
    setFavoriteState(postId, 'false')
      .done(() => {
        removeFavoriteItem($button);
      })
      .fail(() => {
        $button.html(originalHtml);
      });
  });
});

function getFavorites(removePostId = null) {
  $favoritesLoaders.addClass('is_loading');
  const ajax_url = (typeof linku_ajax_url !== 'undefined') ? linku_ajax_url : '/wp/wp-admin/admin-ajax.php';
  const currentPostId = $favoritesContainer.data('postid');

  $.ajax({
    url: ajax_url,
    type: 'post',
    data: {
      action: 'load_favorites',
      remove: removePostId,
      postId: currentPostId,
    },
    dataType: 'json',
    success(response) {
      $favoritesContainer.html(response.favoritesHtml);
      $favoritesLoaders.removeClass('is_loading');
      $favoriteButton = $('.js-favorite-button');
      getFavoriteState();
      if (typeof window.checkAllListingConversations === 'function') {
        window.checkAllListingConversations();
      }
    },
    error(response) {
      console.log('error', response);
    },
  });
}

// One batched request for all buttons instead of one request per card.
function fetchFavoriteStates($buttons) {
  if ($buttons.length === 0) return;

  const ajax_url = (typeof linku_ajax_url !== 'undefined') ? linku_ajax_url : '/wp/wp-admin/admin-ajax.php';
  const postIds = [];
  $buttons.each(function () {
    postIds.push($(this).data('postid'));
  });

  $.ajax({
    url: ajax_url,
    type: 'post',
    data: {
      action: 'get_favourite_states',
      postIds,
    },
    dataType: 'json',
    success(response) {
      const states = (response && response.states) || {};
      $buttons.each(function () {
        const $button = $(this);
        const state = states[$button.data('postid')];
        if (typeof state !== 'undefined') {
          setFavoriteButtonState($button, state);
        }
      });
    },
    error(response) {
      console.log('error', response);
    },
  });
}

function getFavoriteState() {
  fetchFavoriteStates($favoriteButton);
}

function setFavoriteState($postId, $state) {
  const ajax_url = (typeof linku_ajax_url !== 'undefined') ? linku_ajax_url : '/wp/wp-admin/admin-ajax.php';
  return $.ajax({
    url: ajax_url,
    type: 'post',
    data: {
      action: 'set_favourite_state',
      postId: $postId,
      favState: $state,
    },
    dataType: 'json',
    success(response) {
      console.log('response', response);
    },
    error(response) {
      console.log('error', response);
    },
  });
}

function setFavoriteButtonState($elem, $state, $showUpdateMessage = false) {
  if ($state === 'true') {
    $elem.data('state', 'true');
    $elem.html('<i class="fas fa-heart"></i>');
    $elem.removeClass('c-button--ghost');
  } else {
    $elem.data('state', 'false');
    $elem.html('<i class="fal fa-heart"></i>');
    $elem.addClass('c-button--ghost');
  }
}

function removeFavoriteItem($trigger) {
  const $item = $trigger.closest('.col-12.col-sm-6.col-md-4.col-lg-3, .col-12.col-md-9');

  if ($item.length !== 0) {
    $item.remove();
    return;
  }

  const $fallbackItem = $trigger.closest('.c-listing-card, .c-item-card-wrapper, .c-item-card');
  if ($fallbackItem.length !== 0) {
    $fallbackItem.remove();
  } else {
    // Fallback: log a warning when no removable favorite item container is found
    console.warn('removeFavoriteItem: no matching container found for trigger', $trigger);
  }
}

// Called after dynamic content is loaded (e.g. from filters.js getPosts)
function checkFavourites() {
  fetchFavoriteStates($('.js-favorite-button'));
}
